var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none" }, props),
    React.createElement("path", { d: "M4.974 12.54V8.388L.404 2.865C-.538 1.725.274 0 1.755 0h11.75l.136.005c1.393.102 2.126 1.755 1.212 2.86l-4.57 5.524v6.361a.75.75 0 1 1-1.5 0V8.868H6.475v3.671a.75.75 0 0 1-1.5 0zM1.679 1.51a.25.25 0 0 0-.118.4l4.515 5.458H9.18l4.515-5.459a.25.25 0 0 0-.118-.398l-.075-.011H1.753l-.074.01z" })
  );
});